module.exports = __webpack_public_path__ + "static/media/phone_icon_blue.d9a47584.png";